<template>
    <transition name="modal" enter-active-class="animated fadeIn" appear>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body m-0">
                        <slot name="body">
                            <label>شناسه های ثبت شده توسط سایر کاربران:</label>
                           
                            <div class="form-control font-12 line-height-m text-justify div-description" v-html="all_Reference"></div>
                            <br />
                            <div class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-check-square color-magenta2-light"></i>
                                <span class="color-highlight input-style-1-active">شناسه من</span>
                                <input maxlength="150" class="form-control" type="text" v-model="reference">
                            </div>
                            <span v-if="Loading">در حال ارسال اطلاعات...</span>
                        </slot>
                    </div>
                   
                    <div class="modal-footer py-1 px-2">
                        <slot name="footer">
                            <button v-if="readOnly==false" class="btn btn-xxs rounded-s bg-green2-light" @click="SaveRef">
                                <i class="fa fa-check ml-2"></i>
                                ثبت
                            </button>
                            <button class="btn btn-xxs rounded-s bg-red1-light" @click="$emit('close')">
                                <i class="fa fa-times ml-2"></i>
                                بستن
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>



</template>
<script>

    export default {
      
        props: ['taskId', 'taskFolderId'],
        data() {
            return {
                reference: null,
                all_Reference:null,
               
                Loading: false,
                errorMsg: null,
                readOnly:false
            };
        },
        
        mounted() {
            console.log("mounted");
            this.getRef();
        },
        methods: {
            getRef() {
                this.$http.get("Task/GetTaskFolderReference?taskFolderId=" + this.taskFolderId)
                    .then(data => {
                        this.reference = data.data.reference;
                        this.all_Reference = data.data.all_Reference.replace(/\\n/g,'<br/>');
                    });
            },
           
            SaveRef() {
                this.$http.post('task/SaveTaskFolderReference?taskFolderId=' + this.taskFolderId + "&reference=" + this.reference).then(response => {
                    if (response.status == 400 || response.data.success == false) {
                        var res = response.data.errors.map(a => a.errorMessage);
                        this.errorMsg =res;
                    }
                    else {
                        this.$emit('close');
                        this.showSuccessMessage("با موفقیت ثبت شد.");

                    }
                    this.Loading = false;
                }, error => {
                    this.showErrorMessage("خطا در ارسال اطلاعات");
                    this.Loading = false;
                    console.log(error);
                });
            }
        }

    };
</script>
<style>
       .modal-mask {
           position: fixed;
           z-index: 1;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           background-color: rgba(0, 0, 0, 0.5);
           display: table;
           transition: opacity 0.3s ease;
       }

       .modal-wrapper {
           display: table-cell;
           vertical-align: middle;
       }

       .modal-container {
           width: 300px;
           margin: 0px auto;
           background-color: #fff;
           border-radius: 2px;
           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
           transition: all 0.3s ease;
       }

       .modal-header h3 {
           margin-top: 0;
           color: #42b983;
       }

       .modal-body {
           margin: 20px 0;
           line-height: 1;
       }

       .modal-default-button {
           float: right;
       }


       .modal-enter {
           opacity: 0;
       }

       .modal-leave-active {
           opacity: 0;
       }

           .modal-enter .modal-container,
           .modal-leave-active .modal-container {
               -webkit-transform: scale(2);
               transform: scale(2);
           }
</style>
